import s from "./Tips.module.css"

export default function Tips (){
    return <div className={s.Tips}>
        Try for 7 Days Free. Cancel anytime, no contracts.
    </div>

}